module.exports = __webpack_public_path__ + "static/media/6530.e33094c8.jpg";